import { ApiManager } from './ApiManager';
import { DailyStatus, OnboardingSurvey, OnboardingSurveyV2, PatientFile } from './models/SymptomTrackingDTO';

export default class ApiSymptomTrackingManager {
  static async getHistory(): Promise<DailyStatus[]> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/tracking/`);
    return response.data;
  }

  static async getSpecificDailyStatus(day: string): Promise<DailyStatus> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/tracking/${day}/`);
    return response.data;
  }

  static async postSurvey(survey: DailyStatus): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/tracking/`, survey);
  }

  static async fillPeriodDays(startDate: string, endDate: string, menstruationAmount?: number): Promise<void> {
    const apiManager = ApiManager.getInstance();

    const payload: { start_date: string; end_date: string; menstruation_amount?: number } = {
      start_date: startDate,
      end_date: endDate,
    };

    if (menstruationAmount !== undefined) {
      payload.menstruation_amount = menstruationAmount;
    }

    await apiManager.post(`/api/tracking/fill-period-days/`, payload);
  }

  static async removePeriodFromDay(date: string): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/tracking/remove-period-from-day/`, { date });
  }

  static async removePeriodDays(startDate: string, endDate: string): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/tracking/remove-period-days/`, {
      start_date: startDate,
      end_date: endDate,
    });
  }

  static async patchSurvey(survey: DailyStatus): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.patch(`/api/tracking/${survey.date}/`, survey);
  }

  static async postOnboardingSurvey(survey: OnboardingSurvey): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/onboarding/`, survey);
  }

  static async postOnboardingSurveyV2(survey: OnboardingSurveyV2): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/onboarding-v2/`, survey);
  }

  static async postPatientFile(file: PatientFile): Promise<void> {
    const apiManager = ApiManager.getInstance();

    await apiManager.post(`/api/patient-file/`, file);
  }

  static async getOnboardingSurvey(patientId: string): Promise<OnboardingSurvey> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/onboarding/${patientId}/`);
    return response.data;
  }

  static async getOnboardingSurveyV2(patientId: string): Promise<OnboardingSurveyV2> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/onboarding-v2/${patientId}/`);
    return response.data;
  }

  static async getOnboardingSurveyV2Me(): Promise<OnboardingSurveyV2> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/onboarding-v2/me/`);
    return response.data;
  }

  static async getPatientFile(patientId: string): Promise<PatientFile> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/patient-file/${patientId}/`);
    return response.data;
  }

  static async getPatientFileMe(): Promise<PatientFile> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/patient-file/me/`);
    return response.data;
  }
}
